import { ApolloError } from "@apollo/client";
import { errorType } from "src/types/error-types";

type ResponseReducerMode = "GQL";

export type GqlResponseType<TData> = {
  errorMessage: string | undefined;
  code: string | undefined;
  data: TData | undefined;
  error?: any;
};

/**
 * gql response reducer
 * used to reduce gql response to only errorMessage and data
 * @returns
 */
export function responseReducer<TData = any>(
  mode: ResponseReducerMode = "GQL"
) {
  function gqlResponse(
    error: errorType | undefined = undefined,
    data: TData | undefined = undefined
  ) {
    return {
      errorMessage: error?.message,
      code: error?.code,
      error: error,
      data,
    } as GqlResponseType<TData>;
  }

  if (mode === "GQL") return gqlResponse;
  return gqlResponse;
}

export function getGqlError(err: ApolloError | undefined) {
  if (!err) return undefined;
  const error: any = err.networkError;
  return {
    statusCode: error.statusCode,
    message: err.message,
    name: err.name,
  };
}
